module.exports = __webpack_public_path__ + "media/images/main_logo-0b34727888158480fa34c4385e87a41b.png";